const breakpoints = {
  values: {
    xs: 0,
    sm: 490,
    md: 768,
    lg: 1040,
    xl: 1440,
  },
};

export default breakpoints;
